export default "__VITE_ASSET__SqsaQQXG__"